<template>
  <div :class="['flex', 'flex--' + direction, 'flex__gap--' + gap, 'flex__wrap--' + wrap]" data-comp="l-flex">
    <slot />
  </div>
</template>

<script setup>
const props = defineProps({
  display: {
    type: String,
    default: "flex",
    validator: (value) => {
      return ["flex", "inline-flex"].includes(value);
    },
  },
  direction: {
    type: String,
    default: "vertical",
    validator: (value) => {
      return ["vertical", "horizontal", "vertical-reverse", "horizontal-reverse"].includes(value);
    },
  },
  gap: {
    type: String,
    default: "medium",
    validator: (value) => {
      return ["xsmall", "small", "medium", "large", "xlarge"].includes(value);
    },
  },
  justifyContent: {
    type: String,
    default: "flex-start",
    validator: (value) => {
      return ["flex-start", "flex-end", "center", "space-between", "space-around", "space-evenly"].includes(value);
    },
  },
  alignItems: {
    type: String,
    default: "stretch",
    validator: (value) => {
      return ["flex-start", "flex-end", "center", "stretch", "baseline"].includes(value);
    },
  },
  flexGrow: {
    type: Number,
    default: 1,
  },
  wrap: {
    type: String,
    default: "wrap",
    validator: (value) => {
      return ["wrap", "nowrap", "wrap-reverse"].includes(value);
    },
  },
});
</script>

<style lang="scss">
.flex {
  --display: v-bind(props.display);
  --justify-content: v-bind(props.justifyContent);
  --align-items: v-bind(props.alignItems);
  --flex-grow: v-bind(props.flexGrow);
  flex: var(--flex-grow);
  display: var(--display);
  flex-direction: row;
  flex-wrap: wrap;
  gap: var(--flex-gap-small);
  justify-content: var(--justify-content);
  align-items: var(--align-items);
  &__gap {
    &--xsmall {
      gap: var(--flex-gap-xsmall);
    }
    &--small {
      gap: var(--flex-gap-small);
    }
    &--medium {
      gap: var(--flex-gap-medium);
    }
    &--large {
      gap: var(--flex-gap-large);
    }
    &--xlarge {
      gap: var(--flex-gap-xlarge);
    }
  }
  &__wrap {
    &--wrap {
      flex-wrap: wrap;
    }
    &--nowrap {
      flex-wrap: nowrap;
    }
    &--wrap-reverse {
      flex-wrap: wrap-reverse;
    }
  }
  &--vertical {
    flex-direction: column;
  }
  &--vertical-reverse {
    flex-direction: column;
  }
  &--horizontal {
    flex-direction: row;
  }
  &--horizontal-reverse {
    flex-direction: row-reverse;
  }
}
</style>
